import React from "react";
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import { logout } from '../../redux/actions/authenticationActions';
import { Link } from 'react-router-dom';
import { Nav } from "react-bootstrap";
import { Navbar } from "react-bootstrap";
import { NavDropdown } from "react-bootstrap";
import { Container } from "react-bootstrap";
import Subheader from "./Subheader";


class Header extends React.Component {

    render() {
        if (!this.props.authorized) return null


        return (

            <div className="sticky-top" >

                <Navbar expand="xxl" sticky="top">
                    <Container>
                        <Navbar.Brand href="/"> <img src={this.props.apiUrl.replace('espaceClient', 'public/ImageService/image/EspCliMainLogo?nocache=' + Date.now())} alt="logo" ></img></Navbar.Brand>
                        <Navbar.Toggle className='custum-toogler' aria-controls="basic-navbar-nav" />
                        <Navbar.Collapse id="basic-navbar-nav">
                            <Nav className="me-auto">
                                <Nav.Link as={Link} to='/'><span>ACCUEIL</span></Nav.Link>

                                <NavDropdown className="myNavDropDonw" title="MON COMPTE" id="basic-nav-dropdown">
                                    {this.props.currentClient.gestion === true ? <NavDropdown.Item as={Link} to="/Adresses" >MES ADRESSES</NavDropdown.Item> : null}
                                    {this.props.url === 'btf' ? <NavDropdown.Item as={Link} to="/Contacts" >MES CONTACTS</NavDropdown.Item> : null}
                                    {this.props.currentClient.gestion === true ? <NavDropdown.Item as={Link} to="/ModesPaiements" >MES COORDONNEES BANCAIRES</NavDropdown.Item> : null}
                                    <NavDropdown.Divider />
                                    <NavDropdown.Item as={Link} to="/Password" >CHANGER MON MOT DE PASSE</NavDropdown.Item>
                                </NavDropdown>
                                <NavDropdown title="MES SUPPORTS" id="basic-nav-dropdown">
                                    <NavDropdown.Item as={Link} to="/Cards" >MES CARTES</NavDropdown.Item>
                                    <NavDropdown.Item as={Link} to="/Badges" >{this.props.url === 'btf' ? 'MES BOITIERS AUTOROUTE' : 'MES TELEBADGES'}</NavDropdown.Item>
                                </NavDropdown>
                                <Nav.Link as={Link} to="/Factures" >MES FACTURES</Nav.Link>
                                <Nav.Link as={Link} to="/Consommation" >MES TRANSACTIONS</Nav.Link>
                                <Nav.Link as={Link} to="/Ticpe" >MA TICPE</Nav.Link>
                                {(this.props.url === 'btf' && !this.props.parrain.startsWith('SYM') && !this.props.parrain.startsWith('enpc')) ?
                                    <Nav.Link as={Link} to="/Avantage" >MES AVANTAGES</Nav.Link>
                                    : null
                                }
                                <Nav.Link as={Link} to="/" onClick={() => this.props.dispatch(logout())}>DECONNEXION</Nav.Link>
                            </Nav>
                        </Navbar.Collapse>
                    </Container>
                    

                </Navbar>
              
                <Subheader />
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    return ({
        serverConfigLoaded: state.server.initialized,
        authorized: state.authentication.authorized,
        clients: state.authentication.clients,
        currentClient: state.authentication.currentClient,
        contentHeight: state.app.contentHeight,
        apiUrl: state.server.apiUrl,
        url: state.app.url,
        parrain: state.app.parrain
    })
}

Header.propTypes = {
    dispatch: PropTypes.func,
    location: PropTypes.object,
    authorized: PropTypes.bool,
    serverConfigLoaded: PropTypes.bool,
    clients: PropTypes.array,
    currentClient: PropTypes.object,
    contentHeight: PropTypes.number,
    apiUrl: PropTypes.string
};

export default connect(mapStateToProps)(Header);